<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de avaliação de elegibilidade e admissão">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/atencao-basica/relatorio-avaliacao-elegibilidade-admissao/List'

export default {
    components: { List },
}
</script>
